var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 8.83301C2.46056 8.83301 2.83366 8.45991 2.83366 7.99967C2.83366 7.53944 2.46056 7.16634 2.00033 7.16634C1.54009 7.16634 1.16699 7.53944 1.16699 7.99967C1.16699 8.45991 1.54009 8.83301 2.00033 8.83301Z",
    stroke: "#4D4D4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 2.99967C2.46056 2.99967 2.83366 2.62658 2.83366 2.16634C2.83366 1.7061 2.46056 1.33301 2.00033 1.33301C1.54009 1.33301 1.16699 1.7061 1.16699 2.16634C1.16699 2.62658 1.54009 2.99967 2.00033 2.99967Z",
    stroke: "#4D4D4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 14.6663C2.46056 14.6663 2.83366 14.2932 2.83366 13.833C2.83366 13.3728 2.46056 12.9997 2.00033 12.9997C1.54009 12.9997 1.16699 13.3728 1.16699 13.833C1.16699 14.2932 1.54009 14.6663 2.00033 14.6663Z",
    stroke: "#4D4D4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.6a589cab7651a2bc1e0c7658c35cae8b.svg";
export { ForwardRef as ReactComponent };